import { render, staticRenderFns } from "./TextFieldReadonly.vue?vue&type=template&id=8f9689d8&scoped=true"
import script from "./TextFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./TextFieldReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9689d8",
  null
  
)

export default component.exports